module.exports = __webpack_public_path__ + "img/02-other-button.ae083fbc.png";